import React from 'react';

const TelemedIcon = (props) => (
  <svg
    width="11"
    height="21"
    viewBox="0 0 11 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0L2 1.45402V4.36206H0V8.23944H2V15.5095C2 15.5095 2 17.9329 3 18.9022C4.07837 19.9476 4.55405 20.371 6 20.8409C7.67647 21.3857 10.5 20.3563 10.5 20.3563V16.4789C10.5 16.4789 9.04789 16.9868 8 16.4789C7 15.9942 7 14.0555 7 14.0555V8.23944H11V4.36206H7V0Z"
      fill="#FB9318"
    />
  </svg>
);

export default TelemedIcon;
